import { useTrip } from "@/lib/store";
import { TransportCard } from "@/components/TransportCard";
import { SubHeader } from "../More";

export default function Transport() {
  const { trip, organiser } = useTrip();
  return (
    <div className="pb-8">
      <SubHeader eyebrow="Transport" title="Getting around" />
      <p className="mt-2 text-sm text-[var(--ink-muted)]">Times and stations marked TBC haven't been supplied yet.{organiser ? " Use “Complete details” to fill them in." : ""}</p>
      <div data-testid="transport-list" className="mt-4 space-y-4">
        {trip.transports.map((t) => <TransportCard key={t.id} t={t} />)}
      </div>
    </div>
  );
}
